import * as React from 'react';
import { BottomFloat } from '../../components/LandingPageV2/BottomFloat';
import { Header } from '../../components/LandingPageV2/Header';
import { LandingPageLayout } from '../../components/LandingPageV2/LandingPageLayout';
import { AdvantagesContainer } from '../AdvantagesContainer';
import { ContactsControls } from '../ContactsControls';
import { ContactsModalV2Container } from '../ContactsModalWindow';
import { HowItWorksContainer } from '../HowItWorksContainer';
import { QuestionsAndAnswersContainer } from '../QuestionsAndAnswersContainer';
import { RequestFormV2Container } from '../RequestFormV2Container';

export const LandingPageV2Container: React.FC = () => {
  const [isHeaderControlsVisible, setIsHeaderControlsVisible] = React.useState(true);
  const [isFormVisible, setIsFormVisible] = React.useState(false);

  return (
    <div data-testid="landingPageV2">
      <Header
        setIsHeaderControlsVisible={setIsHeaderControlsVisible}
        controls={<ContactsControls phoneDataTestId="ContactsHeaderButton" requestFormDataTestId="RequestFormButton" />}
      />
      <LandingPageLayout>
        <AdvantagesContainer />
        <HowItWorksContainer />
        <RequestFormV2Container setIsFormVisible={setIsFormVisible} />
        <QuestionsAndAnswersContainer />
      </LandingPageLayout>
      <BottomFloat isVisible={!isHeaderControlsVisible && !isFormVisible}>
        <ContactsControls phoneDataTestId="ContactsStickButton" requestFormDataTestId="RequestFormStickButton" />
      </BottomFloat>
      <ContactsModalV2Container />
    </div>
  );
};
